<section style="padding: 20px">
  <mat-tab-group>
  <mat-tab label="Member Ledger">
      <h1>Member Ledger</h1>
      <div *ngFor="let league of leagues" class="player-list" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="league.show_ledger = !league.show_ledger">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div>
              <i class='fa' [ngClass]="{ 'fa-chevron-right': !league.show_ledger, 'fa-chevron-down': league.show_ledger}"></i>
            </div>
            <div>
              {{league.group_name}}
            </div>
          </div>
          <div style="font-weight:700">
              {{league.total_credits | currency}}
          </div>
        </div>
        <div *ngIf="league.show_ledger" fxLayout="column" fxLayoutAlign="start start" style="padding:0 10px">
          <div style="width:100%" fxLayout="column" fxLayoutAlign="start start">
            <div style="font-weight: 700">Player Available Credits: {{league.total_credits | currency}}</div>
            <div>Player Awarded Credits: {{league.credits_awarded | currency}}</div>
            <div>Player Used Credits: {{league.credits_used | currency}}</div>
          </div>
          <div style="width:100%" class="player-list" *ngFor="let ledgerEntry of league.ledger"  fxLayout="row" fxLayoutAlign="space-between start">
            <div fxFlex="40">
              {{ledgerEntry.description}}
            </div>
            <div fxFlex="20" [ngClass]="{'red': ledgerEntry.value_in_cents<0,'green': ledgerEntry.value_in_cents>0 }">
              {{ledgerEntry.value_in_cents/100 | currency}}
            </div>
            <div fxFlex="20">
              {{ledgerEntry.added_by}}
            </div>
            <div fxFlex="20" style="text-align: right">
              {{ledgerEntry.datetime.replace(' ','T') | date: 'short'}}
            </div>
    
          </div>
        </div>
      </div>
  </mat-tab>
</mat-tab-group>
</section><mat-tab-group color="accent">
    
